import { Component, OnInit } from '@angular/core';
import { Translate } from 'src/app/pipe/translate.pipe';

@Component({
  selector: 'app-mission-vision',
  templateUrl: './mission-vision.component.html',
  styleUrls: ['./mission-vision.component.css']
})
export class MissionVisionComponent implements OnInit {

  constructor(private translate: Translate) { }

  ngOnInit(): void {
  }
  getMissions(){
    return this.translate.transform("MISSIONS", 'pipeFilter') as Array<Array<string>>;
  }
  getVisions(){
    return this.translate.transform("VISIONS", 'pipeFilter') as Array<Array<string>>;
  }
  getValori(){
    return this.translate.transform("VALORI", 'pipeFilter') as Array<Array<string>>;
  }
}
